class WiggensbachStreamerTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-wig-streamer-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-wig-streamer-panel]'));

    if (this.tabs.length === 0 || this.panels.length === 0) return;

    this.currentIndex = Math.max(
      0,
      this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')
    );

    this.onClick = (event) => {
      const tab = event.target.closest('[data-wig-streamer-tab]');
      if (!tab || !this.contains(tab)) return;

      this.activateTab(this.tabs.indexOf(tab), true);
    };

    this.onKeyDown = (event) => {
      const tab = event.target.closest('[data-wig-streamer-tab]');
      if (!tab || !this.contains(tab)) return;

      const keyActions = {
        ArrowLeft: this.currentIndex - 1,
        ArrowUp: this.currentIndex - 1,
        ArrowRight: this.currentIndex + 1,
        ArrowDown: this.currentIndex + 1,
        Home: 0,
        End: this.tabs.length - 1,
      };

      if (!(event.key in keyActions)) return;

      event.preventDefault();
      this.activateTab(keyActions[event.key], true);
    };

    this.onBlockSelect = (event) => {
      const selectedPanel = event.target?.closest?.('[data-wig-streamer-panel]');
      if (!selectedPanel || !this.contains(selectedPanel)) return;

      this.activateTab(this.panels.indexOf(selectedPanel), false);
    };

    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeyDown);
    this.addEventListener('shopify:block:select', this.onBlockSelect);

    this.activateTab(this.currentIndex, false);
  }

  disconnectedCallback() {
    if (this.onClick) {
      this.removeEventListener('click', this.onClick);
    }

    if (this.onKeyDown) {
      this.removeEventListener('keydown', this.onKeyDown);
    }

    if (this.onBlockSelect) {
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  }

  activateTab(index, focusTab) {
    if (this.tabs.length === 0) return;

    const normalizedIndex = ((index % this.tabs.length) + this.tabs.length) % this.tabs.length;
    this.currentIndex = normalizedIndex;

    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === normalizedIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');

      if (isActive) {
        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });

    this.panels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === normalizedIndex;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    if (focusTab) {
      this.tabs[normalizedIndex].focus();
    }
  }
}

if (!customElements.get('wiggensbach-streamer-tabs')) {
  customElements.define('wiggensbach-streamer-tabs', WiggensbachStreamerTabs);
}
